import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { errorToast } from "@/shared/ui";
import { updateFollowUpStatus } from "../api";

export const useUpdateFollowUpStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFollowUpStatus,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
    },
    onError: errorToast,
  });
};
